export default "__VITE_ASSET__DTbDSF4Q__"